export const IconCheckmarkDoneGray20: {
  name: 'icon_checkmark_done_gray_20-c8da92c758c2'
} = {
  name: 'icon_checkmark_done_gray_20-c8da92c758c2'
}
